// Init Wholesale Balance Modal Functionality
const initWholesaleBalanceModal = async () => {
  /*
    =========================================
    💻 Modal DOM Functionality
    =========================================
   */

  // Modal Elements - Form, Input, and Modal Toggle Buttons
  const body = document.getElementsByTagName('body')[0]
  const wholesale_balance_modal_togglers = document.querySelectorAll(
    '.wholesale-balance-modal-toggler'
  )

  // 👂 CUSTOM EVENT - [toggleWholesaleBalanceModal] - If the wholesale balance modal is open, add the "wholesale-balance-modal-active" class to the body
  document.addEventListener('toggleWholesaleBalanceModal', function (e) {
    const modalOpen = window.Scoutside.Wholesale.wholesaleBalanceModalOpen
    if (modalOpen) body.classList.add('wholesale-balance-modal-active')
    else body.classList.remove('wholesale-balance-modal-active')

    // Set the details inside the modal
    if (modalOpen) {
      const wholesaleBalanceModalData = JSON.parse(
        window.Scoutside.customer.wholesaleBalanceModalData
      ).data[0]

      let USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      })

      // Set the message
      document.querySelector('[data-wholesale="message"]').innerHTML =
        wholesaleBalanceModalData.message

      document.querySelector('[data-wholesale="notes"]').innerHTML =
        wholesaleBalanceModalData.message

      // Set the Credit Limit
      document.querySelector('[data-wholesale="creditLimit"]').innerHTML =
        USDollar.format(wholesaleBalanceModalData.creditLimit)

      // Set the Account Balance
      document.querySelector('[data-wholesale="accountBalance"]').innerHTML =
        USDollar.format(wholesaleBalanceModalData.accountBalance)

      // Set the currentBalance
      document.querySelector('[data-wholesale="currentBalance"]').innerHTML =
        USDollar.format(wholesaleBalanceModalData.currentBalance)

      // Set the lessThan30Days
      document.querySelector('[data-wholesale="lessThan30Days"]').innerHTML =
        USDollar.format(wholesaleBalanceModalData.lessThan30Days)

      // Set the lessThan60Days
      document.querySelector('[data-wholesale="lessThan60Days"]').innerHTML =
        USDollar.format(wholesaleBalanceModalData.lessThan60Days)

      // Set the lessThan90Days
      document.querySelector('[data-wholesale="lessThan90Days"]').innerHTML =
        USDollar.format(wholesaleBalanceModalData.lessThan90Days)

      // Set the remainingCredit
      document.querySelector('[data-wholesale="remainingCredit"]').innerHTML =
        USDollar.format(wholesaleBalanceModalData.remainingCredit)

      // Set the terms
      document.querySelector('[data-wholesale="terms"]').innerHTML =
        wholesaleBalanceModalData.terms

      // Set the lastPaymentDate
      document.querySelector('[data-wholesale="lastPaymentDate"]').innerHTML =
        wholesaleBalanceModalData.lastPaymentDate

      // Set the lastPaymentAmount
      document.querySelector('[data-wholesale="lastPaymentAmount"]').innerHTML =
        USDollar.format(wholesaleBalanceModalData.lastPaymentAmount)
    }
  })

  // 🖱 CLICK EVENT [".wholesale-balance-modal-toggler"] - window.Scoutside.Wholesale.toggleWholesaleBalanceModal
  wholesale_balance_modal_togglers.forEach((el) =>
    el.addEventListener(
      'click',
      window.Scoutside.Wholesale.toggleWholesaleBalanceModal
    )
  )
}
